import BENEFICIARY_SUBJECT_TYPE_KEY from '@Domain/Subjects/BeneficiarySubjectTypeKey';
import buildSubjectListPath from '@UI/Pages/Beneficiaries/Shared/Helpers/buildSubjectListPath';
import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import InterviewsNotifications from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Interviews/InterviewsNotifications';
import NoteDictationContent from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Interviews/Creations/CreateNotePage/NoteDictationContent';
import useSubjectAddressParams from '@UI/Pages/Beneficiaries/Hooks/Params/useSubjectAddressParams';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Mounted from `…/:dossier/interviews/new/notes?preparation=ID`: dictating a note for
 * a preparation. No form and no consent: the note is dictated straight away. An invalid dossier address
 * redirects to the beneficiary list; the preparation is resolved by the content.
 */
const CreateNotePage: React.FC = () => {
	const navigate = useNavigate();
	const { subject } = useSubjectAddressParams();

	React.useEffect(() => {
		if (subject === null) {
			navigate(buildSubjectListPath(BENEFICIARY_SUBJECT_TYPE_KEY));
		}
	}, [subject, navigate]);

	return (
		<React.Fragment>
			<ConditionalLoader data={subject}>
				{(address) => <NoteDictationContent subject={address} />}
			</ConditionalLoader>
			<InterviewsNotifications />
		</React.Fragment>
	);
};

export default CreateNotePage;
